import _ from "lodash";
import React, { useState } from "react";
import classes from "./ActionForSelectModal.scss";
import PropTypes from "prop-types";
import { Dialog, RadioButton } from "@toddle-edu/ds-web";

const ActionForSelectModal = ({
  t,
  onClose,
  onAction,
  mode,
  confirmButtonText,
  testId,
  isScheduleDateChanged = false,
}) => {
  let recurringDeleteOptions = [
    { key: "calendar:this_meeting_only", value: "THIS" },
    { key: "calendar:this_and_following_meetings", value: "THIS_FOLLOWING" },
  ];
  const [recurringOption, setRecurringOption] = useState(
    recurringDeleteOptions[0].value
  );
  const onRecurringDeletionModalClose = () => {
    onClose(false);
  };

  // when date is not change then only show the all option
  if (!isScheduleDateChanged) {
    // to avoid duplication if re-render happens due to any reason,
    //  we are using uniqBy to make sure all option is there only once
    recurringDeleteOptions = _.uniqBy(
      [
        ...recurringDeleteOptions,
        { key: "calendar:all_meetings", value: "ALL" },
      ],
      "value"
    );
  }
  const getOptionRadioButtons = () => {
    return (
      <div className={classes.checklistContainer}>
        {_.map(recurringDeleteOptions, ({ key, value }) => {
          const onRecurringSelect = () => {
            setRecurringOption(value);
          };
          return (
            <RadioButton
              checked={_.isEqual(recurringOption, value)}
              onChange={onRecurringSelect}
              size={"medium"}
              dsVersion={"2.0"}
              testId={`${testId}-recurringDeleteOption-${value}`}
            >
              {t(key)}
            </RadioButton>
          );
        })}
      </div>
    );
  };

  const handleActionButtonClick = () => onAction(recurringOption);

  const buttonTwoText =
    confirmButtonText ||
    (mode === "edit" ? t("common:update") : t("common:delete"));

  return (
    <Dialog
      variant={"confirm-dialog"}
      isOpen={true}
      title={
        mode === "edit"
          ? t("calendar:update_recurring_meeting")
          : t("calendar:delete_recurring_meeting")
      }
      message={getOptionRadioButtons()}
      buttonOneText={t("common:cancel")}
      buttonTwoText={buttonTwoText}
      onButtonOneClick={onRecurringDeletionModalClose}
      onButtonTwoClick={handleActionButtonClick}
      onClose={onRecurringDeletionModalClose}
      dsVersion={"2.0"}
      testId={`${testId}-recurringOptionEditOrDeleteDialog`}
    />
  );
};

ActionForSelectModal.propTypes = {
  t: PropTypes.func,
  onClose: PropTypes.func,
  onAction: PropTypes.func,
  mode: PropTypes.string,
};

ActionForSelectModal.defaultProps = {
  mode: "delete",
};

export default ActionForSelectModal;
